// extracted by mini-css-extract-plugin
export var lflexContainer = "LeistungenTeaser-module--lflexContainer--VOmtp";
export var lh2 = "LeistungenTeaser-module--lh2--OHnAI";
export var lh3 = "LeistungenTeaser-module--lh3--AqPcl";
export var lleistungContainer = "LeistungenTeaser-module--lleistungContainer--ft6ED";
export var lmainContainer = "LeistungenTeaser-module--lmainContainer--8PktR";
export var lp = "LeistungenTeaser-module--lp--mjzlA";
export var lteaserImage = "LeistungenTeaser-module--lteaserImage--0NKHl";
export var ltextWrapper = "LeistungenTeaser-module--ltextWrapper--BQfCE";
export var lwrapper = "LeistungenTeaser-module--lwrapper--m7ZlJ";